import { render, staticRenderFns } from "./-category.vue?vue&type=template&id=5b053e8a&scoped=true"
import script from "./-category.vue?vue&type=script&lang=js"
export * from "./-category.vue?vue&type=script&lang=js"
import style0 from "./-category.vue?vue&type=style&index=0&id=5b053e8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b053e8a",
  null
  
)

export default component.exports